import { render, staticRenderFns } from "./StringFormatter.vue?vue&type=template&id=dab65a90"
import script from "./StringFormatter.vue?vue&type=script&lang=js"
export * from "./StringFormatter.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.vue?vue&type=style&index=0&id=dab65a90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports